import { Slide } from '@material-ui/core'
import './SingleBar.css'

const SingleBar = ({ title, colour, number, total }) => (
  <div className="singleOuterContainer">
    <div className="titleContainer">
      <p className="title">{title}</p>
    </div>
    <Slide direction="right" in={true}>
      {number > 0 ? (
        <div
          className="bar"
          style={{
            width: `${number === 0 ? 0 : (number / total) * 100}%`,
            backgroundColor: colour,
            minWidth: '47px'
          }}
        >
          {number > 0 && <b className="singleNumber">{number}</b>}
        </div>
      ) : (
        <div
          className="bar"
          style={{
            width: '20px'
          }}
        >
          <b className="singleNumberBlack">{number}</b>
        </div>
      )}
    </Slide>
  </div>
)

export default SingleBar
